import { siteImage } from "./pspricesDeals.service";

const VISORIA_BACKEND_URL =
  process.env.REACT_APP_VISORIA_BACKEND_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  "";
const STEAM_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

async function getJson(url, signal) {
  const response = await fetch(url, {
    headers: { Accept: "application/json" },
    signal,
  });
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }
  return response.json();
}

let ratesPromise = null;
let markupPromise = null;
const QUOTE_RUB = 1000;

const steamSearchService = {
  /** Поиск игр в магазине Steam с ценой региона. */
  search: (region, q, signal) =>
    getJson(
      `${VISORIA_BACKEND_URL}/api/visoria/steam/search?${new URLSearchParams({ region, q })}`,
      signal,
    ).then((data) => ({
      ...data,
      results: (data.results || []).map((game) => ({
        ...game,
        image: siteImage(game.image),
        cover: siteImage(game.cover),
      })),
    })),

  /** Курсы бэкенда пополнения Steam: { USD: 1, RUB, KZT }. */
  rates: () => {
    if (!ratesPromise) {
      ratesPromise = getJson(`${STEAM_BACKEND_URL}/api/currency/rates`)
        .then((data) => data.rates || null)
        .catch(() => {
          ratesPromise = null;
          return null;
        });
    }
    return ratesPromise;
  },

  /** Множитель стоимости пополнения по логину (1.1 = комиссия 10%) — тем же расчётом, что в виджете. */
  topupMarkup: () => {
    if (!markupPromise) {
      markupPromise = fetch(`${STEAM_BACKEND_URL}/api/currency/calculate-price`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ amountRUB: QUOTE_RUB, steamRegion: "RUB" }),
      })
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => (data?.rubPrice > 0 ? data.rubPrice / QUOTE_RUB : null))
        .catch(() => null)
        .then((value) => {
          if (!value) markupPromise = null;
          return value;
        });
    }
    return markupPromise;
  },
};

export default steamSearchService;
